'use client'

import { useTokenStore } from '@/core/services/tokens/memory-token.service'
import {
  UserMessagesModel,
  UserModel,
} from '@/features/auth/types/models/user.model'
import { useInitNotifications } from '@/features/notifications/hooks/use-init-notifications'
import { useObserveNotifications } from '@/features/notifications/hooks/use-observer-notifications'
import { useEffect } from 'react'
import { useAuth } from '.'

type Props = {
  user: UserModel | null
  messages?: UserMessagesModel[]
  accessToken: string | null
}

export function AuthSetter({ user, messages, accessToken }: Props) {
  const { clearUser, setUser, isAuthenticated } = useAuth()
  const { setToken, clearToken } = useTokenStore()
  const initNotifications = useInitNotifications()
  useObserveNotifications()
  useEffect(() => {
    if (!user) {
      clearUser()
    } else {
      setUser(user, messages)
    }
  }, [user, messages, clearUser, setUser])

  useEffect(() => {
    if (accessToken && user?.accountType)
      setToken(accessToken, user.accountType)
    else clearToken()
  }, [accessToken, clearToken, setToken, user?.accountType])

  useEffect(() => {
    if (isAuthenticated) initNotifications()
  }, [initNotifications, isAuthenticated])

  return null
}
